import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const PHOTO_URL =
  "https://customer-assets.emergentagent.com/job_reputation-legal/artifacts/jqxqjt0a_Rechtsanwalt%20Sindros.png";

const schwerpunkte = [
  {
    title: "Löschung unfairer Bewertungen",
    text: "Rechtssichere Entfernung von Google-Rezensionen, Trustpilot-, Kununu-, Jameda- und Booking-Bewertungen. Auf Erfolgsbasis – Sie zahlen nur bei Löschung.",
  },
  {
    title: "Europäisches Internetrecht",
    text: "Beratung und Vertretung im Bereich Medien- und Digitalrecht. Spezialisiert auf den Digital Services Act (DSA) und Plattformregulierung.",
  },
  {
    title: "Persönlichkeitsrecht",
    text: "Schutz vor Rufschädigung, Schmähkritik und Falschbehauptungen im Internet. Durchsetzung von Unterlassungs- und Löschungsansprüchen.",
  },
  {
    title: "Reputationsmanagement",
    text: "Strategische Beratung für Unternehmen zum Schutz und Aufbau der Online-Reputation. Monitoring und präventive Maßnahmen.",
  },
];

const stats = [
  { value: "250.000+", label: "erfolgreich entfernte Bewertungen" },
  { value: "96 %", label: "Erfolgsquote" },
  { value: "Seit 2012", label: "im Internetrecht tätig" },
];

export default function Startseite() {
  useEffect(() => {
    document.title =
      "Rechtsanwalt Sindros – Kanzlei für Internetrecht & Reputationsmanagement";
    const meta = document.querySelector('meta[name="description"]');
    if (meta)
      meta.setAttribute(
        "content",
        "Rechtsanwalt Sindros – spezialisiert auf Internetrecht und Bewertungslöschung. Über 250.000 erfolgreiche Löschungen. Kostenlose Ersteinschätzung."
      );

    // Schema markup
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Attorney",
      name: "Rechtsanwalt Sindros",
      description:
        "Kanzlei für Internetrecht und Online-Reputationsmanagement",
      url: "https://www.rechtsanwalt-sindros.de",
      telephone: "+491784660549",
      email: "info@fairebewertungen.de",
      foundingDate: "2012",
      knowsAbout: [
        "Internetrecht",
        "Online-Reputationsmanagement",
        "Bewertungslöschung",
        "Digital Services Act",
        "Persönlichkeitsrecht",
      ],
      memberOf: { "@type": "Organization", name: "THE PUMA GROUP IKE" },
      areaServed: {
        "@type": "Place",
        name: "Europa (Schwerpunkt DACH)",
      },
    });
    document.head.appendChild(script);
    return () => {
      if (script.parentNode) document.head.removeChild(script);
    };
  }, []);

  return (
    <div>
      {/* Hero */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="animate-fadeIn">
              <h1
                className="text-4xl lg:text-5xl font-bold leading-tight mb-6"
                style={{
                  color: "#1B3A5C",
                  fontFamily: "'Source Serif 4', serif",
                }}
              >
                Ihr Recht auf einen fairen Online-Ruf
              </h1>
              <p
                className="text-lg leading-relaxed mb-10"
                style={{ color: "#555555" }}
              >
                Rechtsanwalt Sindros – spezialisiert auf Internetrecht und
                Online-Reputationsmanagement. Seit 2012.
              </p>
              <Link
                to="/kontakt"
                className="inline-block px-8 py-4 text-white font-medium text-sm rounded"
                style={{
                  backgroundColor: "#1B3A5C",
                  transition: "opacity 0.2s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.88")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
              >
                Kostenlose Ersteinschätzung anfordern
              </Link>
            </div>
            <div
              className="flex justify-center lg:justify-end animate-fadeIn"
              style={{ animationDelay: "0.2s" }}
            >
              <img
                src={PHOTO_URL}
                alt="Rechtsanwalt Sindros"
                className="w-full max-w-md rounded-lg shadow-lg object-cover"
                style={{ aspectRatio: "4/5" }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Schwerpunkte */}
      <section style={{ backgroundColor: "#F5F5F5" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <h2
            className="text-3xl font-bold mb-16 text-center"
            style={{
              color: "#1B3A5C",
              fontFamily: "'Source Serif 4', serif",
            }}
          >
            Schwerpunkte
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {schwerpunkte.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md"
                style={{ transition: "box-shadow 0.3s ease" }}
              >
                <h3
                  className="text-lg font-semibold mb-4"
                  style={{ color: "#1B3A5C" }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-sm leading-relaxed"
                  style={{ color: "#555555" }}
                >
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Zahlen */}
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
            {stats.map((stat, index) => (
              <div key={index}>
                <p
                  className="text-4xl lg:text-5xl font-bold mb-3"
                  style={{
                    color: "#1B3A5C",
                    fontFamily: "'Source Serif 4', serif",
                  }}
                >
                  {stat.value}
                </p>
                <p className="text-sm" style={{ color: "#777777" }}>
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bewertungen löschen */}
      <section style={{ backgroundColor: "#F5F5F5" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
          <div className="max-w-3xl mx-auto text-center">
            <h2
              className="text-3xl font-bold mb-8"
              style={{
                color: "#1B3A5C",
                fontFamily: "'Source Serif 4', serif",
              }}
            >
              Sie möchten eine unfaire Bewertung löschen lassen?
            </h2>
            <p
              className="text-base leading-relaxed mb-10"
              style={{ color: "#555555" }}
            >
              Als eine der erfahrensten Kanzleien Europas im Bereich
              Bewertungsrecht haben wir über 250.000 Bewertungen erfolgreich
              entfernen lassen. In Zusammenarbeit mit unserem spezialisierten
              Team bei Fairebewertungen.de bieten wir Ihnen einen schnellen,
              diskreten und erfolgsbasierten Service.
            </p>
            <a
              href="https://www.fairebewertungen.de/kontakt"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 text-white font-medium text-sm rounded"
              style={{
                backgroundColor: "#1B3A5C",
                transition: "opacity 0.2s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.88")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
            >
              Jetzt Löschung beantragen
            </a>
          </div>
        </div>
      </section>

      {/* Trustpilot Placeholder - hidden until widget is embedded */}
      <section id="trustpilot-section" style={{ display: "none" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
          <h2
            className="text-3xl font-bold mb-8 text-center"
            style={{
              color: "#1B3A5C",
              fontFamily: "'Source Serif 4', serif",
            }}
          >
            Das sagen unsere Mandanten
          </h2>
          <div id="trustpilot-widget" className="min-h-[200px]">
            {/* Trustpilot-Widget wird hier eingebettet */}
          </div>
        </div>
      </section>
    </div>
  );
}
